import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer3TrawaRolka from "../../components/offer/3trawaRolka";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Zakładanie trawników z rolki pod klucz | Gdańsk, Gdynia, Wejherowo, Kaszuby</title>
        <meta name="title" content="Zakładanie trawników z rolki pod klucz | Gdańsk, Gdynia, Wejherowo, Kaszuby" />
        <meta
          name="description"
          content="Błyskawiczny efekt zielonego dywanu! Montaż trawy z rolki wraz z przygotowaniem podłoża i siatką na krety. Usługi w Gdańsku, Gdyni, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Zakładanie trawników z rolki pod klucz | Gdańsk, Gdynia, Wejherowo, Kaszuby"
        />
        <meta
          property="og:description"
          content="Błyskawiczny efekt zielonego dywanu! Montaż trawy z rolki wraz z przygotowaniem podłoża i siatką na krety. Usługi w Gdańsku, Gdyni, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer3TrawaRolka />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
